export enum MediaZoomTypeEnum {
  IMMEDIATE_ZOOM = 'IMMEDIATE_ZOOM',
  PREVIEW_ZOOM = 'PREVIEW_ZOOM',
}
